(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    var burger = document.querySelector('[data-nav-toggle]');
    var menu = document.querySelector('[data-nav-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    document.querySelectorAll('[data-dd-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ola-header__item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.ola-header__item.is-open').forEach(function (o) {
          if (o !== item) { o.classList.remove('is-open'); var b = o.querySelector('[data-dd-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }
        });
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ola-header__nav')) {
        document.querySelectorAll('.ola-header__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var b = o.querySelector('[data-dd-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Anchor the search overlay to the live bottom of the header (accounts for
    // the announcement bar and follows the sticky header while scrolling).
    var sectionHeader = document.querySelector('.section-header');
    function setOverlayTop() {
      if (!sectionHeader) return;
      var bottom = Math.max(0, Math.round(sectionHeader.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--search-overlay-top', bottom + 'px');
    }
    setOverlayTop();
    window.addEventListener('scroll', setOverlayTop, { passive: true });
    window.addEventListener('resize', setOverlayTop);
    var searchDetails = document.querySelector('.header__search details');
    if (searchDetails) { searchDetails.addEventListener('toggle', setOverlayTop); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // WebGL liquid-metal / chrome background. Multi-sphere metaballs (bouncing
    // physics, re-seeded per load) shaded as deep glossy black chrome with a
    // muted warm reflection (iridescence 0). Silhouettes fade to transparency
    // via a view-angle falloff (the smoothstep near the end of the shader) so
    // edges dissolve softly without adding any glow. Honors prefers-reduced-motion.
    function initBlobs(root) {
      var canvas = root.querySelector('[data-hf-canvas]');
      if (!canvas || !canvas.getContext) return;
      var opts = { alpha: true, premultipliedAlpha: false, antialias: true };
      var gl = canvas.getContext('webgl', opts) || canvas.getContext('experimental-webgl', opts);
      if (!gl) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var MAX = 24;          // shader array capacity (must match uBlobs[..] below)
      var COUNT = 16;        // active spheres — lower this if you need more FPS
      var BLEND = 0.4;       // smooth-min radius: higher = gooier merges
      var FOCAL = 1.6, CAMZ = 5.0;   // must match the shader camera
      var SCALE = CAMZ / FOCAL;      // world units per uv unit at the z=0 plane

      var VERT = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
      var FRAG = [
        'precision highp float;',
        'uniform vec2 uRes;uniform float uTime;uniform int uCount;uniform float uK;uniform vec3 uBlobs[24];',
        'float smin(float a,float b,float k){float h=clamp(0.5+0.5*(b-a)/k,0.0,1.0);return mix(b,a,h)-k*h*(1.0-h);}',
        'float map(vec3 p){float d=1e5;for(int i=0;i<24;i++){if(i>=uCount)break;vec3 b=uBlobs[i];float ds=length(p-vec3(b.x,b.y,0.0))-b.z;d=smin(d,ds,uK);}return d;}',
        'vec3 nrm(vec3 p){vec2 e=vec2(0.0015,0.0);return normalize(vec3(map(p+e.xyy)-map(p-e.xyy),map(p+e.yxy)-map(p-e.yxy),map(p+e.yyx)-map(p-e.yyx)));}',
        'vec3 env(vec3 d){float y=d.y;vec3 fl=vec3(0.006,0.004,0.0);vec3 bd=vec3(0.98,0.94,0.86);vec3 cl=vec3(0.03,0.025,0.016);float band=smoothstep(0.18,0.0,abs(y-0.02));vec3 c=mix(fl,cl,smoothstep(-0.6,0.8,y));c=mix(c,bd,band*0.9);float k=pow(max(dot(d,normalize(vec3(0.6,0.5,0.6))),0.0),24.0);float f=pow(max(dot(d,normalize(vec3(-0.7,0.2,-0.3))),0.0),16.0);c+=vec3(1.0,0.85,0.65)*k*0.9;c+=vec3(0.9,0.62,0.35)*f*0.4;return c;}',
        'vec3 irid(float f,float t){vec3 a=vec3(0.5),b=vec3(0.5);vec3 c=vec3(1.0),d=vec3(0.0,0.33,0.67);float ph=f*3.0+t*0.15;return a+b*cos(6.28318*(c*ph+d));}',
        'void main(){vec2 uv=(gl_FragCoord.xy-0.5*uRes)/uRes.y;vec3 ro=vec3(0.0,0.0,5.0);vec3 rd=normalize(vec3(uv,-1.6));float td=0.0;bool hit=false;vec3 p;for(int s=0;s<80;s++){p=ro+rd*td;float dd=map(p);if(dd<0.001){hit=true;break;}td+=dd;if(td>13.0)break;}',
        'if(!hit){gl_FragColor=vec4(0.0);return;}',
        'vec3 n=nrm(p);vec3 v=normalize(ro-p);float ndv=max(dot(n,v),0.0);float alpha=smoothstep(0.0,0.22,ndv);vec3 r=reflect(-v,n);vec3 refl=env(r)*1.1;float fr=pow(1.0-ndv,3.0);vec3 ir=irid(fr,uTime)*0.0*fr;vec3 metal=mix(vec3(0.006),refl,0.9);vec3 col=metal+ir+fr*fr*vec3(0.16,0.12,0.08);vec3 L=normalize(vec3(0.6,0.7,0.5));float sp=pow(max(dot(r,L),0.0),200.0);col+=vec3(1.0,0.96,0.9)*sp*1.4;float lum=dot(col,vec3(0.299,0.587,0.114));col=mix(vec3(lum),col,0.2);col=max(col-0.04,0.0);col*=0.92+0.08*n.y;col=pow(clamp(col,0.0,1.0),vec3(0.4545));gl_FragColor=vec4(col,alpha);}'
      ].join('\n');

      function sh(type, src) {
        var s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        return s;
      }
      var prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, VERT));
      gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FRAG));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
      gl.useProgram(prog);

      var buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'p');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

      var uRes = gl.getUniformLocation(prog, 'uRes');
      var uTime = gl.getUniformLocation(prog, 'uTime');
      var uCount = gl.getUniformLocation(prog, 'uCount');
      var uK = gl.getUniformLocation(prog, 'uK');
      var uBlobs = gl.getUniformLocation(prog, 'uBlobs');

      var px = new Float32Array(COUNT), py = new Float32Array(COUNT);
      var vx = new Float32Array(COUNT), vy = new Float32Array(COUNT);
      var rr = new Float32Array(COUNT);
      var data = new Float32Array(COUNT * 3);
      var Hx = 1, Hy = 1;

      function pack() {
        for (var i = 0; i < COUNT; i++) {
          data[i * 3] = px[i];
          data[i * 3 + 1] = py[i];
          data[i * 3 + 2] = rr[i];
        }
      }

      function seed() {
        var rmax = 0.85 * Math.min(Hx, Hy);
        for (var i = 0; i < COUNT; i++) {
          var r = 0.16 + Math.random() * 0.46;
          if (r > rmax) r = rmax;
          rr[i] = r;
          px[i] = (Math.random() * 2 - 1) * Math.max(0.001, Hx - r);
          py[i] = (Math.random() * 2 - 1) * Math.max(0.001, Hy - r);
          var sp = 0.12 + Math.random() * 0.26;
          var a = Math.random() * 6.28318;
          vx[i] = Math.cos(a) * sp;
          vy[i] = Math.sin(a) * sp;
        }
        pack();
      }

      function sizeCanvas() {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.25);
        var w = root.clientWidth || window.innerWidth;
        var h = root.clientHeight || window.innerHeight;
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        gl.viewport(0, 0, canvas.width, canvas.height);
        var aspect = canvas.width / canvas.height;
        Hx = SCALE * aspect * 0.5;
        Hy = SCALE * 0.5;
      }

      function stepPhysics(dt) {
        for (var i = 0; i < COUNT; i++) {
          var r = rr[i];
          px[i] += vx[i] * dt;
          py[i] += vy[i] * dt;
          if (px[i] < -Hx + r) { px[i] = -Hx + r; vx[i] = -vx[i]; }
          else if (px[i] > Hx - r) { px[i] = Hx - r; vx[i] = -vx[i]; }
          if (py[i] < -Hy + r) { py[i] = -Hy + r; vy[i] = -vy[i]; }
          else if (py[i] > Hy - r) { py[i] = Hy - r; vy[i] = -vy[i]; }
        }
        pack();
      }

      function draw(t) {
        gl.uniform2f(uRes, canvas.width, canvas.height);
        gl.uniform1f(uTime, t);
        gl.uniform1i(uCount, COUNT);
        gl.uniform1f(uK, BLEND);
        gl.uniform3fv(uBlobs, data);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }

      var start = performance.now(), last = start;
      function loop() {
        var now = performance.now();
        var dt = Math.min((now - last) / 1000, 0.05);
        last = now;
        stepPhysics(dt);
        draw((now - start) / 1000);
        requestAnimationFrame(loop);
      }

      sizeCanvas();
      seed();
      if (reduce) { draw(0); } else { requestAnimationFrame(loop); }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          sizeCanvas();
          seed();
          if (reduce) draw(0);
        }, 150);
      });
    }

    function initFinder(root) {
      if (root.__hfInit) return;
      root.__hfInit = true;

      initBlobs(root);

      var shopUrl = root.getAttribute('data-shop-url') || '/collections/all';
      var treeEl = root.querySelector('[data-hf-tree]');
      var stepEl = root.querySelector('[data-hf-step]');
      var progressEl = root.querySelector('[data-hf-progress]');
      var tree;
      try { tree = JSON.parse(treeEl.textContent); } catch (e) { return; }

      var TOTAL = 3;
      var history = ['start'];
      var letters = ['A', 'B', 'C', 'D', 'E'];

      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function current() { return history[history.length - 1]; }

      function renderProgress(depth) {
        var html = '';
        for (var i = 0; i < TOTAL; i++) {
          var cls = 'hf-dot' + (i < depth ? ' is-done' : '') + (i === depth ? ' is-active' : '');
          html += '<span class="' + cls + '"></span>';
        }
        progressEl.innerHTML = html;
      }

      function render() {
        var node = tree[current()];
        if (!node) return;
        renderProgress(node.depth);

        var html = '';
        if (node.final) {
          html += '<div class="hf-step hf-step--final">';
          html += '<p class="hf-eyebrow">Your match</p>';
          html += '<p class="hf-statement">' + esc(node.statement) + '</p>';
          html += '<a class="hf-cta" href="' + esc(shopUrl) + '">Browse Shop All</a>';
          html += '<div class="hf-actions">';
          html += '<button type="button" class="hf-back" data-back>Back</button>';
          html += '<button type="button" class="hf-restart" data-restart>Start over</button>';
          html += '</div>';
          html += '</div>';
        } else {
          html += '<div class="hf-step">';
          html += '<p class="hf-eyebrow">' + esc(node.eyebrow || ('Question ' + (node.depth + 1))) + '</p>';
          html += '<h2 class="hf-question">' + esc(node.q) + '</h2>';
          html += '<div class="hf-options">';
          node.options.forEach(function (o, i) {
            html += '<button type="button" class="hf-option" data-next="' + esc(o.next) + '">';
            html += '<span class="hf-option__k">' + (letters[i] || (i + 1)) + '</span>';
            html += '<span class="hf-option__label">' + esc(o.label) + '</span>';
            html += '<span class="hf-option__chev">→</span>';
            html += '</button>';
          });
          html += '</div>';
          if (history.length > 1) {
            html += '<button type="button" class="hf-back" data-back>Back</button>';
          }
          html += '</div>';
        }
        stepEl.innerHTML = html;
      }

      root.addEventListener('click', function (e) {
        var next = e.target.closest('[data-next]');
        if (next) { history.push(next.getAttribute('data-next')); render(); return; }
        if (e.target.closest('[data-back]')) { if (history.length > 1) { history.pop(); render(); } return; }
        if (e.target.closest('[data-restart]')) { history = ['start']; render(); return; }
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-hf]').forEach(initFinder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olaplex-loader"]) return;
  try {
    
  (function () {
    if (window.__olaGalleryInit) return;
    window.__olaGalleryInit = true;
    function syncRails() {
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      document.querySelectorAll('media-gallery[data-desktop-layout^="thumbnail"]').forEach(function (g) {
        var rail = g.querySelector('.thumbnail-slider');
        if (!rail) return;
        if (!desktop) { rail.style.maxHeight = ''; return; }
        var viewer = g.querySelector('.product__media-list');
        if (viewer) { rail.style.maxHeight = Math.round(viewer.getBoundingClientRect().height) + 'px'; }
      });
    }
    function init() {
      syncRails();
      window.addEventListener('resize', syncRails);
      window.addEventListener('load', syncRails);
      if ('ResizeObserver' in window) {
        document.querySelectorAll('media-gallery[data-desktop-layout^="thumbnail"] .product__media-list').forEach(function (v) {
          try { new ResizeObserver(syncRails).observe(v); } catch (e) {}
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  // Relocates the "Pay over time" installment line (rendered by the theme
  // directly under price) to sit directly under the Add to cart button
  // instead. Runs once on load and again whenever product-info reconnects
  // (variant swaps that replace the whole product-info block), matching how
  // Dawn's product-info.js already patches this section. Ordinary variant
  // changes only patch #price-*/#Inventory-* etc. in place and update the
  // installment form's hidden input by id, so they don't undo this move.
  (function () {
    if (window.__olaInstallmentMoveInit) return;
    window.__olaInstallmentMoveInit = true;
    function moveInstallment(root) {
      (root || document).querySelectorAll('.product__info-container').forEach(function (container) {
        var installmentForm = container.querySelector('form.installment');
        var installmentWrap = installmentForm && installmentForm.closest('div');
        var buyButtons = container.querySelector('.product-form__buttons');
        var productForm = buyButtons && buyButtons.closest('product-form');
        var buyButtonsWrap = productForm && productForm.parentElement;
        if (!installmentWrap || !buyButtonsWrap) return;
        if (buyButtonsWrap.nextElementSibling !== installmentWrap) {
          buyButtonsWrap.insertAdjacentElement('afterend', installmentWrap);
        }
      });
    }
    function init() { moveInstallment(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('product-info:loaded', function (e) { moveInstallment(e.target); });
  })();

  // Renders a small "★★★★☆ N reviews" teaser directly under the product
  // title, linking down to the full reviews section (sections/olaplex-reviews.liquid).
  // Its average/count are read off that section's data-review-* attributes
  // rather than recomputed here, so there's a single source of truth. Hidden
  // entirely when there are zero approved reviews yet, since "0 reviews"
  // under every product title isn't worth showing.
  (function () {
    if (window.__olaRatingTeaserInit) return;
    window.__olaRatingTeaserInit = true;
    function buildTeaser(average, count) {
      var pct = Math.max(0, Math.min(100, average * 20));
      var a = document.createElement('a');
      a.href = '#olaplex-reviews';
      a.className = 'olaplex-rating-teaser';
      a.innerHTML =
        '<span class="olaplex-stars olaplex-stars--sm" aria-hidden="true">' +
          '<span class="olaplex-stars__track">★★★★★</span>' +
          '<span class="olaplex-stars__fill" style="width:' + pct + '%;">★★★★★</span>' +
        '</span>' +
        '<span class="olaplex-rating-teaser__count">' + count + ' review' + (count === 1 ? '' : 's') + '</span>';
      return a;
    }
    function place(root) {
      var reviewsSection = document.querySelector('#olaplex-reviews');
      if (!reviewsSection) return;
      var count = parseInt(reviewsSection.getAttribute('data-review-count') || '0', 10);
      if (!count) return;
      var average = parseFloat(reviewsSection.getAttribute('data-review-average') || '0');
      (root || document).querySelectorAll('.product__info-container').forEach(function (container) {
        if (container.querySelector('.olaplex-rating-teaser')) return;
        var title = container.querySelector('.product__title');
        if (!title) return;
        title.insertAdjacentElement('afterend', buildTeaser(average, count));
      });
    }
    function init() { place(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('product-info:loaded', function (e) { place(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olaplex-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olaReviewsInit) return;
    window.__olaReviewsInit = true;

    function initReviewsBlock(root) {
      var list = root.querySelector('[data-olaplex-review-list]');
      if (!list) return;
      var cards = Array.prototype.slice.call(list.querySelectorAll('.olaplex-review-card'));
      var loadMoreBtn = root.querySelector('[data-olaplex-load-more]');
      var sortSelect = root.querySelector('[data-olaplex-sort]');
      var PAGE_SIZE = 5;
      var revealed = PAGE_SIZE;
      var currentSorted = cards;

      function sortCards(mode) {
        var sorted = cards.slice();
        if (mode === 'highest') {
          sorted.sort(function (a, b) { return (+b.dataset.rating) - (+a.dataset.rating); });
        } else if (mode === 'lowest') {
          sorted.sort(function (a, b) { return (+a.dataset.rating) - (+b.dataset.rating); });
        } else {
          sorted.sort(function (a, b) { return (+b.dataset.date) - (+a.dataset.date); });
        }
        sorted.forEach(function (card) { list.appendChild(card); });
        return sorted;
      }

      function applyVisibility() {
        currentSorted.forEach(function (card, i) {
          card.hidden = i >= revealed;
        });
        if (loadMoreBtn) {
          loadMoreBtn.hidden = revealed >= currentSorted.length;
        }
      }

      currentSorted = sortCards('recent');
      applyVisibility();

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          revealed = PAGE_SIZE;
          currentSorted = sortCards(sortSelect.value);
          applyVisibility();
        });
      }
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          revealed += PAGE_SIZE;
          applyVisibility();
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-olaplex-reviews]').forEach(initReviewsBlock);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-assurance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashAssuranceInit) return;
    window.__splashAssuranceInit = true;

    var mql = window.matchMedia('(min-width: 750px)');

    function getHost(section) {
      return section.closest('.shopify-section') || section;
    }

    function placeInColumn(section, host) {
      var wrapper = document.querySelector('.product__media-wrapper');
      if (!wrapper) return false;
      if (host.parentElement !== wrapper) { wrapper.appendChild(host); }
      section.classList.remove('splash-assurance--after-installment');
      section.classList.add('splash-assurance--in-column');
      return true;
    }

    function placeAfterInstallment(section, host) {
      var installmentForm = document.querySelector('form.installment');
      var installmentWrap = installmentForm && installmentForm.closest('div');
      var anchor = installmentWrap;
      if (!anchor) {
        var buyButtons = document.querySelector('.product-form__buttons');
        var productForm = buyButtons && buyButtons.closest('product-form');
        anchor = productForm && productForm.parentElement;
      }
      if (!anchor) return false;
      if (host.previousElementSibling !== anchor || host.parentElement !== anchor.parentElement) {
        anchor.insertAdjacentElement('afterend', host);
      }
      section.classList.remove('splash-assurance--in-column');
      section.classList.add('splash-assurance--after-installment');
      return true;
    }

    function place() {
      var section = document.querySelector('.splash-assurance');
      if (!section) return;
      var host = getHost(section);
      if (mql.matches) {
        placeInColumn(section, host);
      } else if (!placeAfterInstallment(section, host)) {
        placeInColumn(section, host);
      }
    }

    // Deferred a tick so this always runs after sections/olaplex-loader.liquid's
    // installment-relocation script, regardless of listener registration order,
    // since on mobile this anchors itself to the installment div's CURRENT position.
    function deferredPlace() { setTimeout(place, 0); }

    function init() { deferredPlace(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('product-info:loaded', deferredPlace);
    window.addEventListener('load', deferredPlace);
    if (mql.addEventListener) { mql.addEventListener('change', deferredPlace); }
    else if (mql.addListener) { mql.addListener(deferredPlace); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashBAInit) return;
    window.__splashBAInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.splash-ba').forEach(function (root) {
        root.querySelectorAll('[data-ba-slider]').forEach(function (sl) {
          var range = sl.querySelector('[data-ba-range]');
          if (!range) return;
          var update = function () { sl.style.setProperty('--pos', range.value + '%'); };
          range.addEventListener('input', update);
          update();
        });
        var tabs = root.querySelectorAll('[data-ba-tab]');
        var panels = root.querySelectorAll('[data-ba-panel]');
        tabs.forEach(function (t) {
          t.addEventListener('click', function () {
            var idx = t.getAttribute('data-ba-tab');
            tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
            panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ba-panel') === idx); });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashAccInit) return;
    window.__splashAccInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-splash-accordion]').forEach(function (acc) {
        var items = acc.querySelectorAll('.splash-faq__item');
        items.forEach(function (item) {
          var btn = item.querySelector('[data-acc-trigger]');
          var panel = item.querySelector('[data-acc-panel]');
          if (!btn || !panel) return;
          btn.addEventListener('click', function () {
            var isOpen = item.classList.contains('is-open');
            items.forEach(function (o) {
              o.classList.remove('is-open');
              var b = o.querySelector('[data-acc-trigger]');
              var p = o.querySelector('[data-acc-panel]');
              if (b) b.setAttribute('aria-expanded', 'false');
              if (p) p.style.maxHeight = null;
            });
            if (!isOpen) {
              item.classList.add('is-open');
              btn.setAttribute('aria-expanded', 'true');
              panel.style.maxHeight = panel.scrollHeight + 'px';
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-motion"]) return;
  try {
    
  if (!window.__splashRevealObserverInit) {
    window.__splashRevealObserverInit = true;

    document.addEventListener('DOMContentLoaded', function () {
      var targets = document.querySelectorAll('.splash-reveal');
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  if (!window.__splashScrollTopInit) {
    window.__splashScrollTopInit = true;

    document.addEventListener('click', function (e) {
      var el = e.target.closest('.splash-scroll-top');
      if (!el) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashCountUpInit) return;
    window.__splashCountUpInit = true;
    function parse(str) {
      var s = String(str), i = 0, prefix = '';
      while (i < s.length && !(s[i] >= '0' && s[i] <= '9')) { prefix += s[i]; i++; }
      var numStr = '';
      while (i < s.length && ((s[i] >= '0' && s[i] <= '9') || s[i] === '.' || s[i] === ',')) { numStr += s[i]; i++; }
      var suffix = s.slice(i);
      if (!numStr) return null;
      var hasComma = numStr.indexOf(',') > -1;
      var clean = numStr.replace(/,/g, '');
      var dot = clean.indexOf('.');
      var decimals = dot > -1 ? clean.length - dot - 1 : 0;
      var num = parseFloat(clean);
      if (isNaN(num)) return null;
      return { prefix: prefix, num: num, suffix: suffix, decimals: decimals, hasComma: hasComma };
    }
    function group(intStr) {
      var out = '', c = 0;
      for (var k = intStr.length - 1; k >= 0; k--) { out = intStr[k] + out; c++; if (c % 3 === 0 && k > 0) out = ',' + out; }
      return out;
    }
    function fmt(n, d, comma) {
      var s = n.toFixed(d);
      if (comma) { var p = s.split('.'); p[0] = group(p[0]); s = p.join('.'); }
      return s;
    }
    function run(el) {
      var p = parse(el.getAttribute('data-count-target'));
      if (!p) return;
      var dur = 1300, start = null;
      function step(ts) {
        if (!start) start = ts;
        var prog = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - prog, 3);
        el.textContent = p.prefix + fmt(p.num * eased, p.decimals, p.hasComma) + p.suffix;
        if (prog < 1) requestAnimationFrame(step);
        else el.textContent = p.prefix + fmt(p.num, p.decimals, p.hasComma) + p.suffix;
      }
      requestAnimationFrame(step);
    }
    document.addEventListener('DOMContentLoaded', function () {
      var nums = document.querySelectorAll('[data-splash-countup] .splash-stat__number');
      if (!nums.length) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { io.observe(n); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashStickyInit) return;
    window.__splashStickyInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var bar = document.querySelector('[data-splash-sticky]');
      if (!bar) return;
      var anchor = document.querySelector('.product__info-container') || document.querySelector('.product-form');
      if ('IntersectionObserver' in window && anchor) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var passed = e.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', !e.isIntersecting && passed);
          });
        }, { threshold: 0 });
        io.observe(anchor);
      } else {
        window.addEventListener('scroll', function () { bar.classList.toggle('is-visible', window.scrollY > 640); }, { passive: true });
      }

      // Reserve space at the bottom of the footer equal to the sticky bar's
      // height (product pages only, since this script only runs here), so the
      // fixed bar overlaps that reserved padding rather than the footer content.
      var footerEl = document.querySelector('.footer');
      if (footerEl) {
        var basePad = parseFloat(getComputedStyle(footerEl).paddingBottom) || 0;
        var padFooter = function () {
          footerEl.style.paddingBottom = (basePad + (bar.offsetHeight || 0)) + 'px';
        };
        padFooter();
        window.addEventListener('load', padFooter);
        window.addEventListener('resize', padFooter);
      }

      // Keep the sticky bar's hidden variant id / price / sold-out state in
      // sync with whatever the MAIN buy box's variant picker currently has
      // selected, since this bar no longer has its own picker.
      var hiddenInput = bar.querySelector('[data-sticky-variant-id]');
      var priceEl = bar.querySelector('[data-sticky-price]');
      var submitBtn = bar.querySelector('[data-sticky-submit]');
      var submitText = bar.querySelector('[data-sticky-submit-text]');
      var dataScript = document.querySelector('[data-sticky-variant-data]');
      var variantsById = {};
      if (dataScript) {
        try {
          JSON.parse(dataScript.textContent).forEach(function (v) { variantsById[v.id] = v; });
        } catch (e) {}
      }

      function syncFromVariantId(id) {
        if (!hiddenInput || !id) return;
        hiddenInput.value = id;
        var v = variantsById[id];
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (submitBtn) submitBtn.disabled = !v.available;
        if (submitText) {
          submitText.textContent = v.available ? submitText.getAttribute('data-add-label') : submitText.getAttribute('data-sold-out-label');
        }
      }

      function findMainVariantIdInput() {
        var candidates = document.querySelectorAll('product-form, .product-form');
        for (var i = 0; i < candidates.length; i++) {
          if (bar.contains(candidates[i])) continue;
          var input = candidates[i].querySelector('input[name="id"], select[name="id"]');
          if (input) return input;
        }
        return null;
      }

      function syncFromMain() {
        var mainInput = findMainVariantIdInput();
        if (mainInput) syncFromVariantId(mainInput.value);
      }

      document.addEventListener('change', function (e) {
        if (bar.contains(e.target)) return;
        if (e.target.closest('product-form, .product-form')) {
          setTimeout(syncFromMain, 0);
        }
      });
      document.addEventListener('product-info:loaded', function () { setTimeout(syncFromMain, 0); });

      syncFromMain();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashTstInit) return;
    window.__splashTstInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-splash-carousel]').forEach(function (root) {
        var track = root.querySelector('[data-tst-track]');
        var slides = root.querySelectorAll('[data-tst-slide]');
        var dots = root.querySelectorAll('[data-tst-dot]');
        if (!track || slides.length < 2) return;
        var i = 0, n = slides.length, timer = null;
        function go(idx) { i = (idx + n) % n; track.style.transform = 'translateX(-' + (i * 100) + '%)'; dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); }); }
        function start() { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; timer = setInterval(function () { go(i + 1); }, 6000); }
        function reset() { if (timer) clearInterval(timer); start(); }
        var prev = root.querySelector('[data-tst-prev]');
        var next = root.querySelector('[data-tst-next]');
        if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
        if (next) next.addEventListener('click', function () { go(i + 1); reset(); });
        dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-tst-dot'), 10)); reset(); }); });
        root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
        root.addEventListener('mouseleave', function () { reset(); });
        go(0); start();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-usecases"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Match the collection catalog card button wording: "Choose options" -> "Options",
    // "Add to cart" -> "Add" (olaplex-catalog-loader.liquid does this on catalog pages).
    function relabel(root) {
      root.querySelectorAll('.quick-add__submit').forEach(function (btn) {
        var textNode = null;
        for (var i = 0; i < btn.childNodes.length; i++) {
          var n = btn.childNodes[i];
          if (n.nodeType === 3 && n.textContent.trim()) { textNode = n; break; }
        }
        if (textNode) { textNode.textContent = 'Options'; }
        else if (!btn.disabled) {
          var label = btn.querySelector('span:not(.sold-out-message)');
          if (label && label.textContent.trim()) label.textContent = 'Add';
        }
      });
    }
    // Content is rendered synchronously by Liquid now (no fetch, no
    // recommendations API, no <product-recommendations> custom element), so
    // this just wires up the carousel arrows and the quick-add relabeling
    // once per section instance -- no filtering, no MutationObserver needed.
    function initUC(wrapper) {
      if (wrapper.__ucInit) return;
      var band = wrapper.querySelector('[data-splash-uc]');
      if (!band) return;
      var vp = band.querySelector('[data-uc-viewport]');
      if (!vp) return;
      wrapper.__ucInit = true;
      relabel(band);
      var slide = vp.querySelector('.splash-uc__slide');
      function amount() { return slide ? slide.getBoundingClientRect().width + 32 : vp.clientWidth * 0.8; }
      var prev = band.querySelector('[data-uc-prev]');
      var next = band.querySelector('[data-uc-next]');
      if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { vp.scrollBy({ left: amount(), behavior: 'smooth' }); });
    }
    function boot() {
      document.querySelectorAll('.splash-uc-recs').forEach(initUC);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    window.addEventListener('load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__splashVideoInit) return;
    window.__splashVideoInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-splash-video]').forEach(function (root) {
        var open = root.querySelector('[data-video-open]');
        var lb = root.querySelector('[data-video-lightbox]');
        var embed = root.querySelector('[data-video-embed]');
        var close = root.querySelector('[data-video-close]');
        if (!open || !lb || !embed) return;
        var src = embed.getAttribute('data-src');
        function openLb() {
          if (src) { var sep = src.indexOf('?') > -1 ? '&' : '?'; embed.innerHTML = '<iframe src="' + src + sep + 'autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'; }
          lb.hidden = false; document.body.style.overflow = 'hidden';
        }
        function closeLb() { lb.hidden = true; embed.innerHTML = ''; document.body.style.overflow = ''; }
        open.addEventListener('click', openLb);
        open.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); } });
        if (close) close.addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
